import type { ReactNode } from 'react';

export const symbol_replay_5: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M522-310H405q-11 0-18-7t-7-18q0-11 7-18t18-7h102v-56H405q-11 0-18-7t-7-18v-106q0-11 7-17.5t18-6.5h127q10 0 17 6.5t7 17.5q0 11-6.5 18t-17.5 7H430v57h102q11 0 17.5 6.5T556-441v97q0 14-10 24t-24 10ZM339.5-108Q274-136 225-185t-77-114.5Q120-365 120-440q0-13 8.5-21.5T150-470q13 0 21.5 8.5T180-440q0 125 87.5 212.5T480-140q125 0 212.5-87.5T780-440q0-125-85-212.5T485-740h-22l52 52q9 9 9 21t-9 21q-9 9-21 9t-21-9L368-751q-9-9-9-21t9-21l106-106q8-8 20.5-8t20.5 8q8 8 8 20.5t-8 20.5l-58 58h23q75 0 140.5 28T735-695q49 49 77 114.5T840-440q0 75-28 140.5T735-185q-49 49-114.5 77T480-80q-75 0-140.5-28Z"
		/>
	</svg>
);
